import React, { useState, useEffect } from 'react';
import sanitizeHtml from 'sanitize-html';
import CallAPI from '../commonComponents/AxiosHelper';
import Form from '../commonComponents/Form.v2';
import ModalComponent from '../commonComponents/ModalComponent';

let fileUpload = {
    "createForm": {
        "name": { "name": "tableName", "label": "Table Name", "type": "text", "requiredFlag": true },
        "type": {
            "name": "type", "label": "Table Type", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "Master", "value": "master", },
                { "name": "Transaction", "value": "transaction" },
            ], "requiredFlag": true
        },
        "dataset": {
            "name": "dataset", "label": "Data", "type": "file", "id": "createFile", "requiredFlag": true
        }
    },
    "makeDatasetForm": {
        "datasetName": { "name": "datasetName", "label": "Dataset Name", "type": "text", "requiredFlag": true }
    },
    "overwriteForm": {
        "type": {
            "name": "type", "label": "Overwrite Action", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "Overwrite entire table", "value": 'full' },
                { "name": "Overwrite data for file", "value": "file" },
                { "name": "Overwrite data for period", "value": "period" },
            ], "requiredFlag": true
        },
        "fileName": {
            "name": "fileName", "label": "Select File", "type": "hide", "options": [
                { "name": "Select Option", "value": "" }
            ], "requiredFlag": false,
        },
        "dateColumn": {
            "name": "dateColumn", "label": "Select Date Column", "type": "hide", "options": [
                { "name": "Select Option", "value": "" }
            ], "requiredFlag": false,
        },
        "startDate": {
            "name": "startDate", "label": "Start Date", "type": "hide", "requiredFlag": false,
        },
        "endDate": {
            "name": "endDate", "label": "End Date", "type": "hide", "requiredFlag": false,
        },
        "dataset": {
            "name": "dataset", "label": "Data", "type": "file", "id": "createFile", "requiredFlag": true
        }
    },
    "appendForm": {
        "dataset": {
            "name": "dataset", "label": "Data", "type": "file", "id": "createFile", "requiredFlag": true
        }
    }
}

const FileUpload = (props) => {

    const [overwriteDropDownInfor, setOverwriteDropDownInfor] = useState({})
    const [formDataToUse, setFormDataToUse] = useState({})
    const [formKey, setFormKey] = useState(null)
    const [isProcessing, setIsProcessing] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            jQuery(".custom-file-input").on("change", function () {
                var fileName = jQuery(this).val().split("\\").pop();
                jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
            });
        }, 1);
    }, [formDataToUse])

    useEffect(() => {
        setTimeout(() => {
            $(`#${props.clickInfo.type}Modal`).modal("toggle")
        }, 1);
        if (props.clickInfo.type == "overwrite") {
            let url = '/app/getOverwriteData';
            let params = {
                siteId: props.authData.siteId ? props.authData.siteId : null,
                db_mangement_id: props.clickInfo.information.id,
                email: props.authData.username
            }

            CallAPI('get', url, null, params, 0, function (response) {
                let dropdownInfo = {}
                dropdownInfo.file_names = response.information.file_names;
                dropdownInfo.date_information = response.information.date_information;

                setOverwriteDropDownInfor(dropdownInfo);
                setFormDataToUse(fileUpload[`${props.clickInfo.type}Form`])
                setFormKey(`overwriteForm_${Math.random()}`);

            }, props.authData)
        } else {
            setFormDataToUse(fileUpload[`${props.clickInfo.type}Form`])
            setFormKey(`${props.clickInfo.type}Form_${Math.random()}`);
        }
    }, [props.clickInfo])

    function fileUploadManage(e) {
        let params = {
            siteId: props.authData.siteId ? props.authData.siteId : null,
            email: props.authData.username
        }

        var formData = new FormData();
        let URLToUse = null, file = null;
        let method = "POST"
        let fileUpload = 0
        let form_array = jQuery(`#${props.clickInfo.type}Form`).serializeArray();
        let form_params = {}
        form_array.map(function (innerData) {
            form_params[innerData.name] = sanitizeHtml(innerData.value);
        })
        switch (props.clickInfo.type) {
            case "makeDataset":
                formData = {}
                formData['dataset_name'] = form_params['datasetName'];
                formData['tableName'] = props.clickInfo.information.tableName;

                URLToUse = "/app/make_dataset"
                break;
            case "overwrite":
                file = jQuery('#createFile')[0].files[0];
                formData.append('tableName', props.clickInfo.information.tableName);
                formData.append('uploadedfile', file);
                formData.append('action', props.clickInfo.type);

                if (form_params['type'] == "full")
                    formData.append('overwrite', JSON.stringify({ "full": true }));
                else if (form_params['type'] == "file") {
                    formData.append('overwrite', JSON.stringify({ "filter": { "value": `${form_params['fileName']};file_name` } }));
                }
                else if (form_params['type'] == "period") {
                    formData.append('overwrite', JSON.stringify({ "filter": { "startDate": form_params["startDate"], "endDate": form_params["endDate"], "dateColumn": form_params['dateColumn'] } }));
                }

                URLToUse = "/app/uploadCSV"
                fileUpload = 1
                break;
            case "append":
            case "create":
                file = jQuery('#createFile')[0].files[0];
                if(props.clickInfo.type == "create"){
                    formData.append('tableName', form_params['tableName']);
                    formData.append('type', form_params['type']);
                }else formData.append('tableName', props.clickInfo.information.tableName);
                formData.append('uploadedfile', file);
                formData.append('action', props.clickInfo.type);

                URLToUse = "/app/uploadCSV"
                fileUpload = 1
                break;
        }

        setIsProcessing(true);
        setFormKey(`${props.clickInfo.type}Form_${Math.random()}`);
        if (URLToUse) {
            CallAPI(method, URLToUse, formData, params, fileUpload, function (response) {
                $(`#${props.clickInfo.type}Modal`).modal("toggle")
                setIsProcessing(false);
                setFormKey(`${props.clickInfo.type}Form_${Math.random()}`);
                if (!response.status) {
                    let errorObj = handleErrorMessage(response);
                    alert(errorObj.message);
                    if (errorObj.type == "mapError") {
                        //         let operation = {};
                        //         operation.tableName = form_params['tableName'];
                        //         operation.file = file;
                        //         operation.info = response;
                        //         if (that.state.action == "overwrite") {
                        //             let overwriteCase = that.refs.dataOverwrite.state.condition[that.refs.dataOverwrite.state.overwriteAction]
                        //             operation.overwriteParams = overwriteCase;
                        //         }
                        //         jQuery(".addRow").html(`Submit`);
                        //         jQuery(".addRow").prop(`disabled`, false);
                        //         that.setState({
                        //             operation: operation,
                        //             action: "create"
                        //         });
                    }
                } else {
                    alert("Successfully Uploaded!");
                    //     that.controlPanel(null, null, 'close');
                    //     that.setState({
                    //         isProcessing: false
                    //     })
                }
                props.renderDataAgain()
            }, props.authData);
        }
        e.preventDefault()
    }

    function handleErrorMessage(obj) {

        var errorObj = {
            "message": null,
            "type": null
        }

        var error_info = '';
        if (obj.extra_columns !== null && obj.extra_columns !== undefined) {
            if (obj.extra_columns.file !== undefined && obj.extra_columns.file !== null) {
                if (obj.extra_columns.file.length !== 0) {
                    error_info = 'Extra columns found:\n';
                    for (let i = 0; i < obj.extra_columns.file.length; i++) {
                        error_info += `${i + 1}.${obj.extra_columns.file[i]}.\n`;
                    }
                }
            }
            if (obj.extra_columns.db !== undefined && obj.extra_columns.db !== null) {
                if (obj.extra_columns.db.length !== 0) {
                    error_info = `${error_info}\nMissing Columns found:\n`;
                    for (let i = 0; i < obj.extra_columns.db.length; i++) {
                        error_info += `${i + 1}.${obj.extra_columns.db[i]}.\n`;
                    }
                }
            }
            errorObj.message = error_info
            errorObj.type = "mapError"
        }

        if (obj.tableName !== null && obj.tableName !== undefined) {
            errorObj.message = obj.information;
        }

        return errorObj;

    }

    function dropDownEvents(e) {
        if (props.clickInfo.type == "overwrite") {
            let formData = JSON.parse(JSON.stringify(formDataToUse))
            formData[e.target.name].text_value = e.target.value;
            if (e.target.name == "type") {
                let fileName = null, fileOptionArray = null;
                switch (e.target.value) {
                    case "file":
                        fileName = overwriteDropDownInfor.file_names.split(",");
                        fileOptionArray = fileName.map(function (innerData) {
                            return { "name": innerData, value: innerData }
                        })
                        formData["fileName"]['options'] = [...formData["fileName"]['options'], ...fileOptionArray];
                        formData["fileName"]['requiredFlag'] = true
                        formData["fileName"]['type'] = "dropdown"

                        formData["dateColumn"]['type'] = "hide"
                        formData["dateColumn"]['requiredFlag'] = false
                        formData["startDate"]['type'] = "hide"
                        formData["startDate"]['requiredFlag'] = false
                        formData["endDate"]['type'] = "hide"
                        formData["endDate"]['requiredFlag'] = false
                        break;
                    case "period":
                        fileName = Object.keys(JSON.parse(overwriteDropDownInfor.date_information))
                        fileOptionArray = fileName.map(function (innerData) {
                            return { "name": innerData, value: innerData }
                        })
                        formData["fileName"]['type'] = "hide"

                        formData["dateColumn"]['options'] = [...formData["dateColumn"]['options'], ...fileOptionArray];
                        formData["dateColumn"]['requiredFlag'] = true
                        formData["dateColumn"]['type'] = "dropdown"
                        formData["startDate"]['type'] = "date"
                        formData["startDate"]['requiredFlag'] = true
                        formData["endDate"]['type'] = "date"
                        formData["endDate"]['requiredFlag'] = true
                        break;
                    default:
                        formData["fileName"]['type'] = "hide"
                        formData["fileName"]['requiredFlag'] = false

                        formData["dateColumn"]['type'] = "hide"
                        formData["dateColumn"]['requiredFlag'] = false
                        formData["startDate"]['type'] = "hide"
                        formData["startDate"]['requiredFlag'] = false
                        formData["endDate"]['type'] = "hide"
                        formData["endDate"]['requiredFlag'] = false
                        break;
                }
            }
            setFormDataToUse(formData)
            setFormKey(`overwriteForm_${Math.random()}`);
        }
    }

    var Form_Data = formDataToUse ? <Form label_array={formDataToUse} handle_form_drop_down={props.clickInfo.type == "overwrite" ? dropDownEvents : null} /> : null;

    var modals = {
        "overwriteModal": {
            "form_name": "overwriteForm", "form_id": "overwriteForm", "id": "overwriteModal", "title": "Overwrite Data", "body": Form_Data, "button_name": "Upload", buttonType: "submit", "display": true, "formKey": formKey, "buttonId": "uploadFile"
        },
        "appendModal": {
            "form_name": "appendForm", "form_id": "appendForm", "id": "appendModal", "title": "Append Data", "body": Form_Data, "button_name": "Upload", buttonType: "submit", "display": true, "formKey": formKey, "buttonId": "uploadFile"
        },
        "makeDatasetModal": {
            "form_name": "makeDatasetForm", "form_id": "makeDatasetForm", "id": "makeDatasetModal", "title": "Make As Dataset", "body": Form_Data, "button_name": "Create", buttonType: "submit", "display": true, "formKey": formKey
        },
        "createModal": {
            "form_name": "createForm", "form_id": "createForm", "id": "createModal", "title": "Upload Data", "body": Form_Data, "button_name": "Create", buttonType: "submit", "display": true, "formKey": formKey, "buttonId": "uploadFile"
        }
    }

    let modalToSend = { ...modals[`${props.clickInfo.type}Modal`], ...{ "isLoading": isProcessing } }

    return (
        <>
            {props.clickInfo.type ? <ModalComponent modalConfig={modalToSend} formSubmit={fileUploadManage} /> : null}
        </>
    )
}

export default FileUpload;
